export default function isValidPolicyLink(value: string) {
  return value && value !== "http://example.com";
}
